import { Box, HStack } from "@reverb-ui/react";
import { CustomSelect } from "components/AllowFiltering/CustomSelect";
import { HighlightsContext } from "presentation/containers/context-api";
import { TopExperienceContext } from "presentation/containers/context-api/TopExperienceProvider";
import React, { useContext } from "react";
import { HeaderCard } from "./HeaderCard";
import { TopExperienceSkeleton } from "./Skeleton/TopExperienceSkeleton";
import { TopExperienceData } from "./TopExperienceData";

export interface ITopExperienceProps {
  iconTitle?: string;
}

type TFilterSelectOption = {
  label: string;
  value: string | number;
};

export type TTopExperienceFilterState = {
  sources?: TFilterSelectOption;
  metrics?: TFilterSelectOption;
};

const TopExperience: React.FC<ITopExperienceProps> = ({
  iconTitle = "Star",
}) => {
  const { setValue, topExperienceFilter } = useContext(TopExperienceContext);
  const { isLoading } = useContext(TopExperienceContext);
  const { sources, metrics } = useContext(HighlightsContext);

  return (
    isLoading ? (<TopExperienceSkeleton />) : (
      <Box
        bg="white"
        width="100%"
        height="full"
        display="flex"
        borderRadius="0.625rem"
        justifyContent="center"
      >
        <Box
          width="85%"
          display="flex"
          flexDirection="column"
          justifyContent="flex-start"
          marginTop="1.563rem"
        >
          <HeaderCard title={"TOP 5 EXPERIENCES"} iconName={iconTitle}/>
          <HStack
            display="flex"
            justify="space-between"
            paddingTop="1.875rem"
            width="full"
          >
            <CustomSelect
              options={sources || []}
              value={topExperienceFilter?.sources || null}
              onChange={(value) => setValue && setValue("sources", value)}
            />
            <CustomSelect
              options={metrics || []}
              value={topExperienceFilter?.metrics}
              onChange={(value) => setValue && setValue("metrics", value)}
            />
          </HStack>
          <TopExperienceData />
        </Box>
      </Box>
    )
  );
};

export default TopExperience;
